const POUND_TO_GRAM = 453.59237

export function poundToKiloGram(pound: number) {
  return (pound * POUND_TO_GRAM) / 1000
}
